import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	Button,
	FullBar,
	DialogHandler,
} from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import PropTypes from "prop-types";
import BrandElement from "assets/js/scenes/brand/components/brandElements/BrandElement";
import BrandUpload from "assets/js/scenes/brand/components/brandElements/BrandUpload";
import { showResetDialog } from "assets/js/scenes/brand/utils";
import BrandString from "assets/js/scenes/brand/components/brandElements/BrandString";

const basePath = "images";
let key = new Date().getTime();
export const Logos = (props) => {
	const base = props.localBrand?.images;
	return (
		<div className="brandModalTabContent Logos" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tabs-logo-name" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-modal-tabs-logo-name-title" />}
					desc={<Translate value="app-brand-modal-tabs-logo-name-desc" />}
					path={"name"}
					rightPanel={
						<BrandString
							defaultString={props.brand?.name}
							string={props.localBrand?.name}
							path={"name"}
						/>
					}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-logo-section-title" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-logo-element-title" />}
					desc=<Translate value="app-brand-logo-element-desc" />
					path={basePath + ".logo"}
					rightPanel={
						<BrandUpload
							type="logo"
							defaultImg={base["logo"]}
							path={basePath + ".logo"}
						/>
					}
				/>

				<BrandElement
					title={<Translate value="app-brand-footer-logo-element-title" />}
					desc=<Translate value="app-brand-footer-logo-element-desc" />
					path={basePath + ".injected_logo"}
					rightPanel={
						<BrandUpload
							type="logo"
							defaultImg={base["injected_logo"]}
							path={basePath + ".injected_logo"}
						/>
					}
				/>

				<BrandElement
					className="favicon"
					title={<Translate value="app-brand-favicon-element-title" />}
					desc={<Translate value="app-brand-favicon-element-desc" />}
					path={basePath + ".favicon-android-chrome-512"}
					rightPanel={
						<BrandUpload
							type="favicon"
							defaultImg={base["favicon-android-chrome-512"]}
							path={basePath + ".favicon-android-chrome-512"}
						/>
					}
				/>
			</div>
		</div>
	);
};

Logos.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
};

Logos.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				resellerName: state.brand?.name,
				//Only Reseller otherwise use getCurrentBrandFromState(state)
				brand: state.brand,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(Logos)
);
